export default {
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_BESTELLUNGEN (state, bestellungen) {
    state.bestellungen = bestellungen
  },
  SET_EVALUATIONS (state, evaluations) {
    state.evaluations = evaluations
  }
}
